import * as Yup from 'yup';

export const AddMemberSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 characters'),
  primaryContactEmail: Yup.string()
    .email('Invalid email address')
    .required('Email is required'),
  utilityId: Yup.string()
    .matches(/^[0-9]*$/, 'Please enter positive numbers')
    .min(5, 'Minimum 5 digits')
    .max(6, 'Maximum 6 digits')
});

export const EditMemberSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Minimum 2 characters')
    .max(100, 'Maximum 100 characters'),
  utilityId: Yup.string()
    .matches(/^[0-9]*$/, 'Please enter positive numbers')
    .min(5, 'Minimum 5 digits')
    .max(6, 'Maximum 6 digits')
});
